<h2>Regulatory Review</h2>
<form [formGroup]="form" class="content-align-left">
  <h3 class="section-title">RCRA Regulatory Questions</h3>
  <ng-container formArrayName="regulatoryQuestions">
    <div
      class="form-section"
      *ngFor="let rq of regulatoryQuestions.controls; index as i"
      [formGroupName]="i"
    >
      <div class="inline-grid-view">
        <label>{{ i + 1 }}. {{ rq.value.questionText }}</label>
        <div>
          <mat-radio-group formControlName="response">
            <mat-radio-button value="yes">Yes</mat-radio-button>
            <mat-radio-button value="no">No</mat-radio-button>
          </mat-radio-group>
          <mat-error
            [class]="'regulatory-qestion-' + (i + 1) + '-required'"
            *ngIf="hasFormControlError(rq.value.id, 'response', 'required')"
          >
            Response is <strong>required</strong>
          </mat-error>
        </div>
      </div>

      <ng-template
        [ngIf]="rq.value.type === 'delisted' && rq.value.response === 'yes'"
      >
        <div class="uploader-container">
          <div class="upload-label">
            <label> Attach Final Decision to Delist </label>
            <mat-checkbox formControlName="alreadyUploaded"
              >Already Uploaded</mat-checkbox
            >
            <mat-error
              [class]="'regulatory-qestion-' + (i + 1) + '-upload-required'"
              *ngIf="
                hasFormControlError(
                  rq.value.id,
                  'alreadyUploaded',
                  'required'
                ) || hasFormControlError(rq.value.id, 'attachment', 'required')
              "
              >Please attach final decision to delist
            </mat-error>
          </div>
          <div class="upload-data">
            <digital-platform-file-upload
              formControlName="attachment"
            ></digital-platform-file-upload>
          </div>
        </div>
      </ng-template>
      <ng-template
        [ngIf]="
          rq.value.type === 'hazardousCharacteristics' &&
          rq.value.response === 'yes'
        "
      >
        <div class="input-container margin-top">
          <label class="label-small">
            Identify the applicable waste code and specify whether the waste is
            hazardous as defined by Federal, State or both.
          </label>
          <mat-form-field appearance="outline">
            <input
              maxlength="50"
              matInput
              formControlName="applicableWasteCodesAndAgents"
            />
            <mat-error
              [class]="
                'regulatory-qestion-' +
                (i + 1) +
                '-applicable-waste-code-required'
              "
              *ngIf="
                hasFormControlError(
                  rq.value.id,
                  'applicableWasteCodesAndAgents',
                  'required'
                )
              "
            >
              This is a required field
            </mat-error>
            <mat-error
              [class]="
                'regulatory-qestion-' +
                (i + 1) +
                '-applicable-waste-code-max-length'
              "
              *ngIf="
                hasFormControlError(
                  rq.value.id,
                  'applicableWasteCodesAndAgents',
                  'maxlength'
                )
              "
            >
              Maximum of 100 character allowed
            </mat-error>
          </mat-form-field>
        </div>
      </ng-template>
      <ng-template
        [ngIf]="
          rq.value.type === 'hazardousRegulatoryCitation' &&
          rq.value.response === 'yes'
        "
      >
        <div class="input-container margin-top size-half">
          <label class="label-small"> Corresponding Regulatory Citation </label>
          <mat-form-field appearance="outline">
            <input
              maxlength="100"
              matInput
              formControlName="regulatorCitation"
            />
            <mat-error
              [class]="
                'regulatory-qestion-' + (i + 1) + '-regulator-citation-required'
              "
              *ngIf="
                hasFormControlError(
                  rq.value.id,
                  'regulatorCitation',
                  'required'
                )
              "
            >
              This is a required field
            </mat-error>
          </mat-form-field>
        </div>
      </ng-template>
    </div>
  </ng-container>
  <ng-container formArrayName="rsHandlingQuestions">
    <h3 class="section-title">Republic Waste Handling</h3>
    <div
      class="form-section"
      *ngFor="let rs of rsHandlingQuestions.controls; index as i"
      [formGroupName]="i"
    >
      <div class="inline-grid-view">
        <label> {{ i + 1 }}. {{ rs.value.questionText }} </label>
        <div>
          <mat-radio-group formControlName="response">
            <mat-radio-button value="yes">Yes</mat-radio-button>
            <mat-radio-button value="no">No</mat-radio-button>
          </mat-radio-group>
          <mat-error
            [class]="'handling-qestion-' + (i + 1) + '-required'"
            *ngIf="hasFormControlError(rs.value.id, 'response', 'required')"
          >
            Response is <strong>required</strong>
          </mat-error>
        </div>
      </div>
      <ng-template
        [ngIf]="rs.value.type === 'tsdLike' && rs.value.response === 'yes'"
      >
        <div class="uploader-container">
          <div class="upload-label">
            <label class="label-small">
              Upload supporting documentation such as a waste analysis plan or
              describe in the text box
            </label>
            <mat-form-field appearance="outline">
              <textarea
                maxlength="270"
                formControlName="description"
                matInput
                matTextareaAutosize
                matAutosizeMinRows="4"
                matAutosizeMaxRows="8"
              ></textarea>
              <mat-error
                [class]="
                  'handling-qestion-' + (i + 1) + '-description-required'
                "
                *ngIf="
                  hasFormControlError(rs.value.id, 'description', 'required')
                "
              >
                Supporting documentation or a description is
                <strong>Reqiured</strong>
              </mat-error>
            </mat-form-field>
          </div>
          <div class="upload-data">
            <digital-platform-file-upload
              formControlName="attachment"
            ></digital-platform-file-upload>
          </div>
        </div>
      </ng-template>
    </div>
  </ng-container>
</form>
